import { VueRenderer } from '@tiptap/vue-3';
import tippy from 'tippy.js';
import MentionList from './MentionList.vue';
import { KeyboardKey } from '@/constants/constants';
import type { TippyPopup } from '@/features/App/AppTextEditor/extensions/Emoji/types';
import type { SuggestionOptions } from '@tiptap/suggestion';

export const MentionSuggestion: Omit<SuggestionOptions, 'editor'> = {
	items: () => {
		// vue component will be doing the fetching instead of doing it here
		return [];
	},

	render: () => {
		let component: VueRenderer;
		let popup: TippyPopup;

		return {
			onStart: async (props) => {
				component = new VueRenderer(MentionList, {
					props,
					editor: props.editor,
				});

				if (!props.clientRect) {
					return;
				}

				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore-next-line
				popup = tippy('body', {
					getReferenceClientRect: props.clientRect,
					appendTo: () => document.body,
					content: component.element,
					showOnCreate: true,
					interactive: true,
					trigger: 'manual',
					placement: 'bottom-start',
				})[0];
			},

			onUpdate(props) {
				component.updateProps(props);

				if (!props.clientRect) {
					return;
				}

				popup.setProps({
					getReferenceClientRect: props.clientRect,
				});
			},

			onKeyDown(props) {
				switch (props.event.key) {
					case KeyboardKey.ARROW_RIGHT:
					case KeyboardKey.ARROW_LEFT:
					case KeyboardKey.ARROW_DOWN:
					case KeyboardKey.ARROW_UP:
						props.event.preventDefault();
						break;
					case KeyboardKey.ESC:
						popup.hide();
						component.destroy();
						return true;
					default:
						break;
				}

				return component.ref?.onKeyDown(props);
			},

			onExit() {
				popup.destroy();
				component.destroy();
			},
		};
	},
};
